export const RoleReducer = (state, action) => {
    switch (action.type) {
        case "SET_INTIAL_DATA":
            return {
                ...state,
                ...action.payload
            }
        case "TOGGLE_CREATE_ROLE_DIALOG":
            return {
                ...state,
                showCreateRoleDialog: !state.showCreateRoleDialog,
                roleName: "",
                toUpdateRole: {},
                nameError: {
                    isValid: true,
                    message: ""
                }
            }
        case "TOGGLE_DELETE_ROLE_DIALOG":
            return {
                ...state,
                showDeleteRoleDialog: !state.showDeleteRoleDialog
            }
        case "SET_LOADER":
            return {
                ...state,
                processingRole: action.payload
            }
        case "HANDLE_ROLE_NAME_CHANGE":
            return {
                ...state,
                roleName: action.payload.roleName,
                nameError: action.payload.nameError,
            }
        case "HANDLE_SPLITTER_CHANGE":
            return {
                ...state,
                panes: action.payload
            }
        case "SET_SELECTED_ROLE":
            debugger
            return {
                ...state,
                selectedRole: action.payload,
                inProgressItems: [],
                savedItems: [],
                selectedEntity: {},
                entityInProgressItems: [],
                entitySavedItems: [],
                attributeInProgressItems: [],
                attributeSavedItems: [],
                pageInProgressItems: [],
                pageSavedItems: [],
                otherRightsInProgressItems: [],
                otherRightsSavedItems: []
            }
        case "SET_DELETING_ROlE":
            return {
                ...state,
                toDeleteRole: action.payload
            }
        case "SET_UPDATING_ROlE":
            return {
                ...state,
                showCreateRoleDialog: true,
                toUpdateRole: action.payload,
                roleName: action.payload.roleName
            }
        case "ADD_ROLE":
            return {
                ...state,
                ...action.payload
            }
        case "UPDATE_ROLE":
            return {
                ...state,
                ...action.payload
            }
        case "DELETE_ROLE":
            return {
                ...state,
                ...action.payload
            }
        case "UPDATE_ROLES":
            return {
                ...state,
                selectedRole: {
                    ...state.selectedRole,
                    ...action.payload.properties,
                },
                data: state.data.map(role => {
                    if (role._id === action.payload._id) {
                        return {
                            ...role,
                            ...action.payload.properties
                        };
                    }
                    return role;
                })
            }
        case "ADD_TO_INPROGRESS":
            return {
                ...state,
                inProgressItems: [...state.inProgressItems, action.payload],
                savedItems: state.savedItems.filter(item => item !== action.payload)
            }
        case "MOVE_TO_SAVE":
            return {
                ...state,
                inProgressItems: state.inProgressItems.filter(item => item !== action.payload),
                savedItems: [...state.savedItems, action.payload]
            }
        case "SET_SELECTED_ENTITY_RIGHTS_TAB":
            return {
                ...state,
                selectedEntityRightsTab: action.payload
            }
        case "SET_ENTITIES":
            return {
                ...state,
                entities: action.payload
            }
        case "SET_ENTITY_LOADER":
            return {
                ...state,
                loadingEntities: action.payload
            }
        case "SET_SELECTED_ENTITY":
            return {
                ...state,
                selectedEntity: action.payload,
                attributeInProgressItems: [],
                attributeSavedItems: [],
                pageInProgressItems: [],
                pageSavedItems: [],
                otherRightsInProgressItems: [],
                otherRightsSavedItems: []
            }
        case "ENTITY_ADD_TO_INPROGRESS":
            return {
                ...state,
                entityInProgressItems: [...state.entityInProgressItems, action.payload],
                entitySavedItems: state.entitySavedItems.filter(item => item !== action.payload)
            }
        case "ENTITY_MOVE_TO_SAVE":
            return {
                ...state,
                entityInProgressItems: state.entityInProgressItems.filter(item => item !== action.payload),
                entitySavedItems: [...state.entitySavedItems, action.payload]
            }
        case "UPDATE_ENTITIES":
            return {
                ...state,
                entities: state.entities.map(entity => {
                    if (entity._id === action.payload._id) {
                        return action.payload.properties
                    }
                    return entity
                })
            }
        case "SET_ATTRIBUTES":
            return {
                ...state,
                attributes: action.payload
            }
        case "SET_ATTRIBUTE_LOADER":
            return {
                ...state,
                loadingAttributes: action.payload
            }
        case "SET_SELECTED_ATTRIBUTE":
            return {
                ...state,
                selectedAttribute: action.payload
            }
        case "ATTRIBUTE_ADD_TO_INPROGRESS":
            return {
                ...state,
                attributeInProgressItems: [...state.attributeInProgressItems, action.payload],
                attributeSavedItems: state.attributeSavedItems.filter(item => item !== action.payload)
            }
        case "ATTRIBUTE_MOVE_TO_SAVE":
            return {
                ...state,
                attributeInProgressItems: state.attributeInProgressItems.filter(item => item !== action.payload),
                attributeSavedItems: [...state.attributeSavedItems, action.payload]
            }
        case "UPDATE_ALL_ATTRIBUTES":
            return {
                ...state,
                attributes: state.attributes.map(attribute => {
                    if (action.payload.entityPermission === "Full access" && attribute.isSystemAttribute) {
                        return {
                            ...attribute,
                            roleRights: {
                                ...attribute.roleRights,
                                [action.payload.properties.roleId]: {
                                    permission: "Readonly"
                                }
                            }
                        }
                    }
                    return {
                        ...attribute,
                        roleRights: {
                            ...attribute.roleRights,
                            [action.payload.properties.roleId]: {
                                permission: action.payload.properties.permission
                            }
                        }
                    }
                })
            }
        case "UPDATE_ATTRIBUTES":
            return {
                ...state,
                attributes: state.attributes.map(attribute => {
                    if (attribute._id === action.payload._id) {
                        return { ...action.payload.properties }
                    }
                    return attribute
                })
            }
        case "SET_PAGES":
            return {
                ...state,
                pages: action.payload
            }
        case "SET_PAGE_LOADER":
            return {
                ...state,
                loadingPages: action.payload
            }
        case "SET_SELECTED_PAGE":
            return {
                ...state,
                selectedPage: action.payload
            }
        case "PAGE_ADD_TO_INPROGRESS":
            return {
                ...state,
                pageInProgressItems: [...state.pageInProgressItems, action.payload],
                pageSavedItems: state.pageSavedItems.filter(item => item !== action.payload)
            }
        case "PAGE_MOVE_TO_SAVE":
            return {
                ...state,
                pageInProgressItems: state.pageInProgressItems.filter(item => item !== action.payload),
                pageSavedItems: [...state.pageSavedItems, action.payload]
            }
        case "UPDATE_ALL_PAGES":
            return {
                ...state,
                pages: state.pages.map(page => {
                    if (action.payload.entityPermission === "Read only" && (page.subPageType === "New Record" || page.subPageType === "Edit Record")) {
                        return {
                            ...page,
                            access: false
                        }
                    }
                    return {
                        ...page,
                        ...action.payload.properties
                    }
                })
            }
        case "UPDATE_PAGES":
            return {
                ...state,
                pages: state.pages.map(page => {
                    if (page.id === action.payload.id) {
                        return {
                            ...page,
                            ...action.payload.properties
                        }
                    }
                    return page
                })
            }
        case "SET_OTHER_RIGHTS":
            return {
                ...state,
                ...action.payload
            }
        case "SET_OTHER_RIGHTS_LOADER":
            return {
                ...state,
                loadingOtherRights: action.payload
            }
        case "OTHER_ADD_TO_INPROGRESS":
            return {
                ...state,
                otherRightsInProgressItems: [...state.otherRightsInProgressItems, action.payload],
                otherRightsSavedItems: state.otherRightsSavedItems.filter(item => item !== action.payload)
            }
        case "OTHER_MOVE_TO_SAVE":
            return {
                ...state,
                otherRightsInProgressItems: state.otherRightsInProgressItems.filter(item => item !== action.payload),
                otherRightsSavedItems: [...state.otherRightsSavedItems, action.payload]
            }
        case "UPDATE_LIST_RIGHTS":
            return {
                ...state,
                listData: { ...state.listData, ...action.payload }
            }
        case "UPDATE_CHARTS_RIGHTS":
            return {
                ...state,
                chartsData: { ...state.chartsData, ...action.payload }
            }
        case "UPDATE_ALL_OTHER_RIGHTS":
            return {
                ...state,
                listData: { ...state.listData, access: action.payload, manage: action.payload },
                chartsData: { ...state.chartsData, access: action.payload, manage: action.payload }
            }
        default:
            return state
    }
}